var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),(_vm.alert.message)?_c('div',{class:("alert " + (_vm.alert.type))},[_vm._v("\n    "+_vm._s(_vm.alert.message)+"\n  ")]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }